import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssignedService {

  constructor(private ws: PostmethodService) { }

  getAssignedList(queryParams: any) {
    return this.ws.wsGet(environment.baseUrl + "/lead/leads?" + queryParams);
  }

}
